export const stepsHeaders = [
    "Company Details",
    "Financial Data",
    "Supply Chain Data",
    "EcoVadis Program",
    "Final Results"
];